import React, {useContext, useEffect, useState} from "react";
import {metricEnumKeyMap} from "../../../../utils/enums";
import {SingleMetric} from "../../common/OverviewGeneralInfo/SingleMetric";
import {OptionalDays} from "../../../../config/generals";
import {
    extractOverviewMetrics,
    getMetricChangePercent
} from "../../common/OverviewGeneralInfo/OverviewHelpers";
import {ITagMetrics} from "@leap4/entities-discrepancy-common";
import {UserViewsContext} from "../../../../contexts/userViewsContext";


export interface IHomePageGeneralInfoProps {
    data: ITagMetrics
    comparisonData: { compare: OptionalDays, data: ITagMetrics }
}

const HomeGeneralInfo = ({data, comparisonData}: IHomePageGeneralInfoProps): JSX.Element => {
    const {userViews} = useContext(UserViewsContext)
    const [initialAllMetrics] = useState(extractOverviewMetrics(data))
    const [selectedDatesMetrics, setSelectedMetrics] = useState(extractOverviewMetrics(data))
    const [selectedComparisonMetrics, setSelectedComparisonMetrics] = useState(extractOverviewMetrics(comparisonData.data))

    useEffect(() => {
        const {overviewViews} = userViews.activePreset
        const newSelectedMetrics = {}
        overviewViews.forEach(view => {
            newSelectedMetrics[view] = initialAllMetrics[view]
        })
        setSelectedMetrics(newSelectedMetrics as any)
        setSelectedComparisonMetrics(extractOverviewMetrics(comparisonData.data))
    }, [userViews, comparisonData])
    return (
        <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            gap: '16px',
        }}>
            {Object.entries(selectedDatesMetrics).map(([metricKey, metricValue]) => {
                const comparedValue = selectedComparisonMetrics[metricKey]
                return (
                    <div key={metricKey} style={{ textAlign: 'center', minWidth: '120px', flex: '1 1 auto' }}>
                        <SingleMetric
                            metricValue={metricValue as number} 
                            metricEnum={metricEnumKeyMap[metricKey]?.label}
                            metricChange={getMetricChangePercent(metricValue, comparedValue)}
                        />
                    </div>
                )
            })}
        </div>
    )
}

export {HomeGeneralInfo}

